module.exports = __webpack_public_path__ + "media/images/auth-redirect-e015167d.png";